import { TableCell, TableRow } from "@mui/material";
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { useState } from "react";

const CollapsibleRow = ({
  headers,
  keyValue,
  selectedQuotes,
  getCellClass,
  statusColors,
  headername,
  handleClick,direction
}) => {
  const [sortDirection, setSortDirection] = useState(direction);
  if (!headers[keyValue]) {
    return null;
  }

  const headerLabel = headers[keyValue];
  const isHeaderMatching = headerLabel === headers[headername];

  const onHeaderClick = () => {
    setSortDirection((prev) => (prev === "asc" ? "desc" : prev === "desc" ? "asc" : "asc"));
    handleClick();
  };

  const renderArrow = () => {
    if (sortDirection === "asc") {
      return <ArrowUpwardIcon sx={{ fontSize: 15, marginLeft: 0.6 }} />;
    } else if (sortDirection === "desc") {
      return <ArrowDownwardIcon sx={{ fontSize: 15, marginLeft: 0.6 }} />;
    }
    return null;
  };

  return (
    <TableRow
      key={keyValue}
      className={isHeaderMatching ? "tabrow" : "tabrowWhite"}
      onClick={(e) => {
        if (e.currentTarget.classList.contains("tabrow")) {
          onHeaderClick();
        }
      }}
    >
      <TableCell
        size="small"
        className={isHeaderMatching ? "fixedColumntwo" : "fixedColumnoneWhite"}
      >
        {headerLabel}
        {isHeaderMatching && renderArrow()}
      </TableCell>
      {selectedQuotes?.[keyValue]?.map((data, index) => (
        <TableCell
          key={index}
          size="small"
          className={getCellClass(index, keyValue)}
          sx={{
            color: keyValue === "statusName" ? statusColors?.[data] : "black",
          }}
        >
          {data}
        </TableCell>
      ))}
    </TableRow>
  );
};

export default CollapsibleRow;
